import axios from "axios";
import { ResetPasswordDataDto, SetNewPasswordDataDto } from "../reset-password/models";

export const sendLink = (request: ResetPasswordDataDto) => {
    return axios.post("Auth/ResetPassword", request);
}

export const confirmNewPassword = (request: SetNewPasswordDataDto) => {
    return axios.post("Auth/ResetPasswordConfirmation", request);
}